export default "__VITE_ASSET__CUwOCcmX__"